export * from './button';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/button/index.js
// module id = 277
// module chunks = 0